import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

import { API_PATH } from "@/constants/config";
import { request } from "@/helper/http";
import { type Announcement, type AnnouncementResponse } from "@/types/announcement";
import { type APIResponse } from "@/types/global";

const getActiveAnnouncements = (): Promise<APIResponse<AnnouncementResponse>> => {
  return request({
    method: "GET",
    url: `${API_PATH.ANNOUNCEMENTS_ACTIVE}`,
  });
};

export const announcementApi = createApi({
  reducerPath: "announcementApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Announcements"],
  endpoints: (builder) => ({
    getActiveAnnouncements: builder.query<Announcement | undefined, void>({
      queryFn: async (): Promise<{ data: Announcement | undefined } | { error: unknown }> => {
        try {
          const response = await getActiveAnnouncements();
          const result = response.results[0];
          if (!result) {
            return { data: undefined };
          }
          return {
            data: {
              id: result.id,
              message: result.message,
              startDate: result.start_date,
              endDate: result.end_date,
            },
          };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Announcements"],
    }),
  }),
});

export const { useGetActiveAnnouncementsQuery } = announcementApi;
